{
  "app": {
    "title": "Lead Management Dashboard",
    "description": "Manage your leads efficiently"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "leads": "Leads",
    "settings": "Settings"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search",
    "filter": "Filter",
    "filterItems": "Filter...",
    "noResults": "No results found",
    "selected": "Selected",
    "export": "Export",
    "import": "Import",
    "loading": "Loading...",
    "noData": "No data available",
    "error": "An error occurred",
    "success": "Success"
  },
  "dashboard": {
    "title": "Dashboard",
    "welcome": "Welcome to {{displayName}}",
    "totalLeads": "Total Leads",
    "newLeads": "New Leads",
    "convertedLeads": "Converted Leads",
    "pendingLeads": "Pending Leads"
  },
  "leads": {
    "title": "Leads",
    "addLead": "Add Lead",
    "editLead": "Edit Lead",
    "deleteLead": "Delete Lead",
    "name": "Name",
    "email": "Email",
    "phone": "Phone",
    "status": "Status",
    "source": "Source",
    "createdAt": "Created At",
    "updatedAt": "Updated At"
  },
  "login": {
    "subtitle": "We'll sign you in or create an account if you don't have one yet.",
    "authenticating": "Signing you in...",
    "emailPlaceholder": "Enter your email",
    "continueWithEmail": "Continue with email",
    "otpSubtitle": "We have sent a one-time password to your email",
    "otpInstruction": "Please paste (or type) your 6-digit code:",
    "verifying": "Checking code...",
    "agreementPrefix": "We will process your data as set forth in our",
    "dataProcessingAgreement": "Data Processing Agreement"
  },
  "sequence": {
    "default": "DEFAULT",
    "setTooltip": "Click to Set Sequence for this Type",
    "modifyTooltip": "Click to Modify Sequence for this Type",
    "resetToDefault": "Reset to Default"
  },
  "addContact": {
    "title": "Add Contact",
    "firstName": "First Name",
    "firstNamePlaceholder": "e.g. John",
    "lastName": "Last Name",
    "lastNamePlaceholder": "e.g. Smith",
    "jobTitle": "Title",
    "jobTitlePlaceholder": "e.g. Senior Product Designer",
    "emailAddress": "Email Address",
    "emailPlaceholder": "e.g. john@company.com",
    "adding": "Adding...",
    "closeModal": "Close modal"
  },
  "deleteLead": {
    "confirmMessage": "You're about to permanently delete \"{{leadName}}\". This will remove all associated contacts, profiles, and enrichment data.",
    "deleting": "Deleting...",
    "closeModal": "Close modal"
  },
  "deleteContact": {
    "title": "Delete Contact",
    "confirmMessage": "Are you sure you want to delete \"{{contactName}}\"? This will remove the contact from this lead."
  },
  "reachOut": {
    "title": "Select Sequence",
    "confirm": "Confirm",
    "cancel": "Cancel",
    "sending": "Sending...",
    "success": "Added to sequence",
    "failed": "Failed to add",
    "skipped": "Skipped",
    "reachOut": "Reach Out"
  },
  "generateMore": {
    "pipelineGemini": "Fetch from Gemini",
    "pipelineApollo": "Fetch from Apollo (Hardcoded to Shopify)"
  },
  "gifPreview": {
    "sitePreview": "Site Preview",
    "previewUnavailable": "Preview unavailable",
    "regenerate": "Regenerate",
    "regenerating": "Regenerating...",
    "siteIdCopied": "Site ID copied",
    "copySiteId": "Copy Site ID",
    "expandPreview": "Expand preview",
    "closePreview": "Close preview"
  },
  "generateLeads": {
    "typeCount_one": "{{count}} type",
    "typeCount_other": "{{count}} types",
    "typeCountFiltered_one": "{{filtered}} of {{total}} type",
    "typeCountFiltered_other": "{{filtered}} of {{total}} types"
  },
  "manageLeads": {
    "leadCount_one": "{{count}} lead",
    "leadCount_other": "{{count}} leads",
    "leadCountFiltered_one": "{{filtered}} of {{total}} lead",
    "leadCountFiltered_other": "{{filtered}} of {{total}} leads"
  },
  "settings": {
    "title": "Settings",
    "general": "General",
    "profile": "Profile",
    "language": "Language",
    "theme": "Theme",
    "notifications": "Notifications"
  }
}
